






































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import commons from "@/common/store/modules/commons";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "NaviItemLinkForSpOnGeneral",
  components: {
    IconBase,
    IconArrowRight,
    TextLabelNewArrivalCount
  }
})
export default class NaviItemLinkForSpOnGeneral extends Vue {
  @Prop({ type: String, default: "/", required: true }) url!: string;
  @Prop({ type: String, default: "リンク", required: true }) label!: string;
  @Prop({ type: String, default: "#000000" }) iconColor!: string;
  @Prop({ type: [Number, String, Boolean], default: false })
  notificationCount!: number | boolean | string;
  @Prop({ type: String, default: "_self" }) target!: string;
  get formatNotificationCount() {
    const notificationCount = this.notificationCount;
    if (typeof notificationCount === "number" || notificationCount === false) {
      return notificationCount;
    }
    //return parseInt(notificationCount, 10);
    return parseInt(notificationCount.toString(), 10);
  }
  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }
}
